<template>
	<flickity ref="flickity" :options="flickityOptions" class="product-carousel">
		<slot></slot>
	</flickity>
</template>

<script>
	import FlickityimagesLoaded from 'flickity-imagesloaded';
	import Flickity from 'vue-flickity';

	export default {

		components: {
			Flickity,
		},

		data () {
			return {
				flickityOptions: {
					imagesLoaded: true,
					percentPosition: false,
					cellSelector: '.home-product-col-card',
					prevNextButtons: false,
					pageDots: true,
					initialIndex: 1,
					//dragThreshold: 10,
				}
			}
		},

		mounted() {
			let isScrolling
			let flick = this.$refs.flickity
			window.addEventListener('scroll', function ( event ) {

				flick.disableDrag()
				window.clearTimeout( isScrolling )
				isScrolling = setTimeout(function() {
					flick.enableDrag()
				}, 100)
			}, false)
			flick.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
				if (!cellElement) {
					return
				}
				flick.selectCell(cellIndex)
			})

			document.querySelectorAll('.product-carousel .home-product-col-card').forEach(function (element, index) {
				if(element.classList.contains('initial')) {
					flick.selectCell(index)
				}
			});
		},

	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ProductCarousel.vue